var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑卡券" : "添加卡券",
            width: "70%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "140px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品名称：",
                    prop: "productName",
                    rules: [
                      {
                        required: true,
                        message: "请输入商品名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "productName", $$v)
                      },
                      expression: "pram.productName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品金额：",
                    prop: "productAmount",
                    rules: [
                      {
                        required: true,
                        message: "请输入商品金额",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { clearable: "", placeholder: "请输入" },
                      model: {
                        value: _vm.pram.productAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "productAmount", $$v)
                        },
                        expression: "pram.productAmount",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("¥")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "使用人群：", prop: "targetAudience" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.handleCompanySearch,
                        loading: _vm.companySearchLoading,
                        clearable: "",
                        placeholder: "请输入关键词搜索",
                      },
                      model: {
                        value: _vm.pram.targetAudience,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "targetAudience", $$v)
                        },
                        expression: "pram.targetAudience",
                      },
                    },
                    _vm._l(_vm.companyOptions, function (item) {
                      return _c("el-option", {
                        key: item.tagId,
                        attrs: { label: item.tagName, value: item.tagId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "非工会会员是否使用：",
                    prop: "unionMemberUse",
                    rules: [
                      {
                        required: true,
                        message: "请选择工会会员是否使用",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.unionMemberUse,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "unionMemberUse", $$v)
                        },
                        expression: "pram.unionMemberUse",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "返福豆：",
                    prop: "returnFudou",
                    rules: [
                      {
                        required: true,
                        message: "请输入返福豆",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.returnFudou,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "returnFudou", $$v)
                      },
                      expression: "pram.returnFudou",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "福卡选择：", prop: "returnFudouId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.handleFucardSearch,
                        loading: _vm.fucardSearchLoading,
                        clearable: "",
                        placeholder: "请输入关键词搜索福卡",
                      },
                      model: {
                        value: _vm.pram.returnFudouId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "returnFudouId", $$v)
                        },
                        expression: "pram.returnFudouId",
                      },
                    },
                    _vm._l(_vm.fucardOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.card_name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "库存量：",
                    prop: "inventory",
                    rules: [
                      {
                        required: true,
                        message: "请输入库存量",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.inventory,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "inventory", $$v)
                      },
                      expression: "pram.inventory",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "项目有效期：",
                    prop: "validityType",
                    rules: [
                      {
                        required: true,
                        message: "请选择项目有效期",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.handleValidityTypeChange },
                      model: {
                        value: _vm.pram.validityType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "validityType", $$v)
                        },
                        expression: "pram.validityType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "days" } }, [
                        _vm._v("购买后几日有效"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "date" } }, [
                        _vm._v("指定有效日期"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.validityType === "days"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "有效天数：",
                        prop: "validityDays",
                        rules: [
                          {
                            required: true,
                            message: "请输入有效天数",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.pram.validityDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "validityDays", $$v)
                          },
                          expression: "pram.validityDays",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.validityType === "date"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "有效日期：",
                        prop: "validityDate",
                        rules: [
                          {
                            required: true,
                            message: "请选择有效日期",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.pram.validityDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "validityDate", $$v)
                          },
                          expression: "pram.validityDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "停车场：",
                    prop: "parkingLot",
                    rules: [
                      {
                        required: true,
                        message: "请选择停车场",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.handleParkingLotSearch,
                        loading: _vm.parkingLotSearchLoading,
                        clearable: "",
                        placeholder: "请输入关键词搜索停车场",
                      },
                      model: {
                        value: _vm.pram.parkingLot,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "parkingLot", $$v)
                        },
                        expression: "pram.parkingLot",
                      },
                    },
                    _vm._l(_vm.parkingLotOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择商品状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("上架")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("下架")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "卡券备注：",
                    prop: "remark",
                    rules: [
                      {
                        required: true,
                        message: "请输入卡券备注",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3, placeholder: "请输入" },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }